import { Suspense, lazy, memo } from 'react'

import { TPageProps } from '~/shared/types/commonTypes'

const Heartbeat = lazy(
  () => import('~/pages/onboarding/quizSingleChoice/libs/components/Heartbeat'),
)
const Bear = lazy(
  () => import('~/pages/onboarding/quizSingleChoice/libs/components/Bear'),
)
const Plant = lazy(
  () => import('~/pages/onboarding/quizSingleChoice/libs/components/Plant'),
)
const SocialMediaStatement = lazy(
  () =>
    import(
      '~/pages/onboarding/quizSingleChoice/libs/components/SocialMediaStatement'
    ),
)
const DailyGoal = lazy(
  () => import('~/pages/onboarding/quizSingleChoice/libs/components/DailyGoal'),
)
const Age = lazy(
  () => import('~/pages/onboarding/quizSingleChoice/libs/components/Age'),
)
const Gender = lazy(
  () => import('~/pages/onboarding/quizSingleChoice/libs/components/Gender'),
)

const QuizSingleChoiceRoot = ({ nextPagePath, pageId }: TPageProps) => (
  <Suspense fallback={null}>
    <Age nextPagePath={nextPagePath} pageId={pageId} />
    <Gender nextPagePath={nextPagePath} pageId={pageId} />
    <Heartbeat nextPagePath={nextPagePath} pageId={pageId} />
    <Bear nextPagePath={nextPagePath} pageId={pageId} />
    <Plant nextPagePath={nextPagePath} pageId={pageId} />
    <SocialMediaStatement nextPagePath={nextPagePath} pageId={pageId} />
    <DailyGoal nextPagePath={nextPagePath} pageId={pageId} />
  </Suspense>
)

const QuizSingleChoice = Object.assign(memo(QuizSingleChoiceRoot), {
  Heartbeat,
  Bear,
  Plant,
  SocialMediaStatement,
  DailyGoal,
  Age,
  Gender,
})

export default QuizSingleChoice
